<template>
    <div class="d-flex align-center justify-center" style="height: 100vh">
        <v-sheet width="400" class="mx-auto pa-6 elevation-3 rounded-lg">
            <h2 class="text-center mb-6">{{ isRegister ? '新規ユーザー登録' : 'ログイン' }}</h2>
            <v-form fast-fail @submit.prevent="submitForm">
                <v-text-field 
                    v-model="user_id" 
                    label="ログインID (半角英数字)"
                    :rules="[rules.required]"
                ></v-text-field>

                <v-text-field 
                    v-if="isRegister"
                    v-model="name" 
                    label="表示名 (ニックネーム等)"
                    :rules="[rules.required]"
                ></v-text-field>

                <v-text-field 
                    v-if="isRegister"
                    v-model="mail" 
                    label="メールアドレス"
                    :rules="[rules.required]"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-icon="passwordshow ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="passwordshow ? 'text' : 'password'"
                    label="パスワード"
                    hint="4文字以上で入力してください"
                    counter
                    @click:append="passwordshow = !passwordshow"
                ></v-text-field>

                <div class="text-right mt-1 mb-3" v-if="!isRegister">
                    <a href="#" class="text-body-2 text-decoration-none text-primary">パスワードを忘れた場合</a>
                </div>

                <v-btn type="submit" color="primary" block class="mt-2 py-5" style="height: 44px; font-weight: bold;">
                    {{ isRegister ? '登録する' : 'ログイン' }}
                </v-btn>

            </v-form>
            <div class="mt-6 text-center">
                <p class="text-body-2" v-if="!isRegister">
                    アカウントをお持ちでないですか？ 
                    <a href="#" @click.prevent="isRegister = true" class="text-decoration-none text-primary font-weight-bold">新規登録</a>
                </p>
                <p class="text-body-2" v-else>
                    すでにアカウントをお持ちですか？ 
                    <a href="#" @click.prevent="isRegister = false" class="text-decoration-none text-primary font-weight-bold">ログイン</a>
                </p>
            </div>
        </v-sheet>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            isRegister: false,
            user_id: '',
            name: '',
            mail: '',
            password: '',
            passwordshow: false,
            rules: {
                required: value => !!value || '必須項目です',
                min: v => v.length >= 4 || '4文字以上で入力してください',
                emailMatch: () => (`メールアドレスとパスワードが一致しません`),
            },
        };
    },
    methods: {
        submitForm() {
            if (this.isRegister) {
                this.register();
            } else {
                this.login();
            }
        },
        login() {
            axios.post(process.env.VUE_APP_API_URL + '/api/login', {
                user_id: this.user_id,
                password: this.password
            })
            .then( res => {
                console.log(res)
                this.$store.dispatch('saveToken', res.data)
                // ホームに戻す
                this.$router.push('/mypage')
            })
            .catch( e => {
                alert("ログインに失敗しました。ユーザーIDかパスワードが間違っています。")
                console.log(e)
            })
        },
        register() {
            axios.post(process.env.VUE_APP_API_URL + '/api/users', {
                user_id: this.user_id,
                name: this.name,
                mail: this.mail,
                password: this.password
            })
            .then( () => {
                alert("新規登録が完了しました。ログインしてください。")
                // 登録成功後はログイン画面に戻し、パスワード欄をクリア
                this.isRegister = false;
                this.password = '';
            })
            .catch( e => {
                alert("新規登録に失敗しました。すでに使用されているユーザーID等の可能性があります。")
                console.log(e)
            })
        }
    },
}
</script>